<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

@if (state === 'good') {
    <div>
        <div mat-dialog-title class="font-header6">How would you like to launch?</div>
        <div mat-dialog-content class="playtest-launch-dialog-content font-body2">
            You can launch Playtest in either the native app (if installed), or just use your browser.
        </div>
        <div mat-dialog-actions [align]="'end'">
            <a
                [href]="getSanitizedUrl('native')"
                target="_self"
                mat-button
                color="primary"
                class="hig-button-overlay"
                matRipple
                matRippleColor="white"
            >
                <span class="font-button2" (click)="onLaunchClick()">Native App</span>
            </a>
            <a
                [href]="getSanitizedUrl('browser')"
                target="_blank"
                mat-button
                color="primary"
                class="hig-button-overlay"
                matRipple
                matRippleColor="white"
            >
                <span class="font-button2" (click)="onLaunchClick()">Browser App</span>
            </a>
        </div>
    </div>
}
@if (state === 'waiting') {
    <div>
        <div mat-dialog-title class="font-header6">Preparing Test</div>
        <div mat-dialog-content class="playtest-launch-dialog-content font-body2">
            Please wait while the playtest is being prepared.
        </div>
        <div mat-dialog-actions [align]="'end'">
            <button mat-flat-button class="font-button2" (click)="onLaunchClick()">Cancel</button>
        </div>
    </div>
}
@if (state === 'error') {
    <div>
        <div mat-dialog-title class="font-header6">Playtest Failed</div>
        <div mat-dialog-content class="playtest-launch-dialog-content font-body2">
            Preparing the playtest failed for an unknown reason. Please try again later.
        </div>
        <div mat-dialog-actions [align]="'end'">
            <button mat-flat-button class="font-button2" (click)="onLaunchClick()">OK</button>
        </div>
    </div>
}
